module.exports = __webpack_public_path__ + "static/media/004.eb22b194.jpg";